import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import TopNavFour from "../../../components/header/TopNavFour";
import img1 from "../../../assets/images/shape/shape_38.svg";
import img2 from "../../../assets/images/shape/shape_39.svg";
import InnerBanner from "../../../components/page-title/InnerBanner";
import FaqTwo from "../../../components/faq/FaqTwo";
import Tilt from "react-parallax-tilt";
import NewsLetterForm from "../../../components/form/NewsLetterForm";
import ContactTwo from "../../../components/contact/ContactTwo";
import FooterFour from "../../../components/footer/FooterFour";
import CopyRightFour from "../../../components/footer/CopyRightFour";
// import img1 from "../../../assets/images/shape/TT.svg";
// import img2 from "../../../assets/images/shape/chitra3.svg";
import HeroBannerTen from "../../../components/hero-banner/HeroBannerTen";
import TestimonialOne from "../../../components/testimonial/TestimonialOne";
// import BrandTwo from "../../../components/brand/BrandTwo";

const FAQ = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="main-page-wrapper">
      {/* <Helmet>
        <title>Technology Consulting </title>
      </Helmet> */}
      {/* helmet end */}
      <TopNavFour /> {/* theme-menu-four */}
      <HeroBannerTen />
      {/* /.theme-inner-banner */}
      <div className="faq-section-one mt-130 mb-150 lg-mt-80 lg-mb-80">
        <div className="container">
          {/* <div className="row">
            <div className="col-xxl-10 col-xl-11 m-auto">
              <div className="row">
                <div className="col-xl-4 col-lg-3">
                  <ul className="faq-list-item style-none md-mb-60">
                    <li className="active">
                      <a href="#">
                        1. <span>Makreting</span>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        2. <span>Buying</span>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        3. <span>User Manual</span>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        4. <span>Payments</span>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        5. <span>TermsConditions</span>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        6. <span>Account</span>
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="col-xl-8 col-lg-9" data-aos="fade-left">
                  <h3 className="faq-title">Marketing</h3>
                  <FaqTwo />
                </div>
              </div>
            </div>
          </div> */}
          {/* <p>
            Once a business owner defined the needs to take a business to the
            next level, a decision maker will define a scope, cost and a time
            frame of the project. The role of the IT consultancy company is to
            support and nurture the company from the very beginning of the
            project until the end, and deliver the project not only in the
            scope, time and cost but also with complete customer satisfaction.
          </p> */}
        </div>
        {/* /.container */}
      </div>
      <div className="fancy-feature-twelve mt-130 pb-50 lg-mt-80">
        <div className="container">
          <div className="row align-items-center align-items-xl-start">
            <div className="col-xl-5 col-md-6 order-md-last">
              <div className="block-style-nine color-two">
                <div className="title-style-three pb-10" data-aos="fade-up">
                  <div className="sc-title">WHY CHOOSE US</div>
                  <h2 className="main-title">
                    Why <span>choose us</span> for your business.
                  </h2>
                </div>
                {/* /.title-style-three */}
                <ul className="style-none list-item">
                  <li data-aos="fade-up">
                    Our strong sense of identification with client projects
                    means that we are constantly striving to provide solutions,
                    even for issues they aren’t yet aware of.{" "}
                  </li>
                  <li data-aos="fade-up" data-aos-delay={100}>
                    It’s our attention to the small stuff, scheduling of
                    timelines and keen project management that makes us stand
                    out from the rest.
                  </li>
                  <li data-aos="fade-up" data-aos-delay={200}>
                    We bring our diverse background of advertising, design,
                    branding, public relations, research and strategic planning
                    to work for company.
                  </li>
                </ul>
              </div>
              {/* /.block-style-nine */}
            </div>
            <div
              className="col-xl-7 col-md-6 order-md-first"
              data-aos="fade-right"
            >
              <div className="illustration-holder position-relative d-inline-block pe-md-5 me-xxl-5 sm-mt-60">
                <Tilt tiltMaxAngleX={5} tiltMaxAngleY={5}>
                  <img
                    src="images/assets/ils_18.svg"
                    alt="Graphics"
                    className="transform-img-meta"
                  />
                </Tilt>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="inner-content mt-90 lg-mt-60">
        <div className="slider-wrapper">
          <TestimonialOne />
          {/* /.feedback_slider_one */}
        </div>
        {/* /.slider-wrapper */}
      </div>
      <div className="mt-100 lg-mt-70">
        <div className="container">
          <ContactTwo />
        </div>
      </div>
      {/* <img src="images/shape/shape_46.svg" alt="" className="shapes bg-shape" /> */}
      {/* /.faq-section-one */}
      <div className="footer-style-four theme-basic-footer">
        <div className="container">
          <div className="inner-wrapper">
            <div className="subscribe-area">
              <div className="row align-items-center">
                <div className="col-md-6">
                  <div className="title-style-four sm-pb-20">
                    <h4 className="main-title">
                      Join Our <span>Newsletter</span> &amp; Get updated.
                    </h4>
                  </div>
                  {/* /.title-style-four */}
                </div>
                <div className="col-md-6">
                  <div className="subscribe-form">
                    <NewsLetterForm />
                    <p>We only send interesting and relevant emails.</p>
                  </div>
                  {/* /.subscribe-form */}
                </div>
              </div>
            </div>
            {/* /.subscribe-area */}
            <FooterFour />
            <div className="bottom-footer">
              <CopyRightFour />
            </div>
          </div>
          {/* /.inner-wrapper */}
        </div>
      </div>
      {/* /.footer-style-four */}
    </div>
  );
};

export default FAQ;
